import { Injectable } from '@angular/core';
import { ControlButton } from './viewModels/layout.viewModel';

@Injectable({
  providedIn: 'root',
})
export class CoreService {
  private _topControlButtons: ControlButton[];
  private _sideControlButtons: ControlButton[];
  private _rtlEnabled: boolean = true;
  private _showLoader: boolean = false;
  private _loaderText: string = 'loading';

  constructor() {}

  public set topControlButtons(controls: ControlButton[]) {
    this._topControlButtons = controls;
  }
  public get topControlButtons(): ControlButton[] {
    return this._topControlButtons;
  }

  public set sideControlButtons(controls: ControlButton[]) {
    this._sideControlButtons = controls;
  }
  public get sideControlButtons(): ControlButton[] {
    return this._sideControlButtons;
  }

  public get rtlEnabled(): boolean {
    return this._rtlEnabled;
  }
  public set rtlEnabled(value: boolean) {
    this._rtlEnabled = value;
  }

  public get showLoader(): boolean {
    return this._showLoader;
  }
  public set showLoader(state: boolean) {
    this._showLoader = state;
  }

  public get loaderText(): string {
    return this._loaderText;
  }
  public set loaderText(text: string) {
    this._loaderText = text;
  }
}
